module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "container auth-view-wrapper"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/images/logo.png"),
      "alt": "Reev"
    }
  }), _c('fieldset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.emailRecovered),
      expression: "!emailRecovered"
    }],
    on: {
      "change": _vm.setDirty,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('legend', {
    staticClass: "auth-legend"
  }, [_vm._v("Recupere sua senha")]), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.apiErrorMessages), function(message) {
    return _c('div', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(message))])
  }), 0), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.email),
      expression: "credentials.email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "user-email",
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.credentials.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "email", $event.target.value)
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    key: "email",
    staticClass: "help-block text-left"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])])], 1), _c('button', {
    staticClass: "btn btn-block btn-primary submit-button",
    attrs: {
      "type": "submit",
      "disabled": !_vm.submittable
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Enviar instruções por email")]), _c('router-link', {
    staticClass: "login-link",
    attrs: {
      "to": "login"
    }
  }, [_vm._v("Voltar")])], 1), _c('fieldset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.emailRecovered),
      expression: "emailRecovered"
    }]
  }, [_vm._m(0), _c('button', {
    staticClass: "btn btn-block btn-primary submit-button back-button",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goToLogin()
      }
    }
  }, [_vm._v("Ok, voltar para o login")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', {
    staticClass: "auth-legend password-feedback"
  }, [_c('b', [_vm._v("E-mail enviado!")]), _vm._v(" Siga as instruções enviadas por e-mail para a redefinição da sua senha.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5d89e328!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/sessions/recover_password.vue
// module id = 1141
// module chunks = 1